import {Axios} from "../../../axiosHelper";
import {AxiosError, AxiosResponse} from "axios";
import {mqttStatisticsActions} from "../../slice/efe/mqttStatisticsSlice";
import {MqttStatisticsResponse, Stat} from "../../data/mqttStatistics";
import {ChartData} from "tmwx-design-common";

export const getMqttStatistics = (): any => {
    return async (dispatch: any) => {
        dispatch(mqttStatisticsActions.setLoading(true));

        Axios.get("efe/statistics/mqtt")
            .then((res: AxiosResponse<MqttStatisticsResponse>) => {
                dispatch(mqttStatisticsActions.setIncomingMsgs(convertStatsToChartData(res.data.incomingMsgs)));
                dispatch(mqttStatisticsActions.setSubscriptions(convertStatsToChartData(res.data.subscriptions)));
                dispatch(mqttStatisticsActions.setConnectedCount(res.data.connectedCount));
            })
            .catch((err: AxiosError) => {
                if (err.response) {
                    if (err.response.status === 400) {
                        const resp: any = err.response.data;
                        dispatch(mqttStatisticsActions.setError(resp));
                    }
                }
            });
    };
};

function convertStatsToChartData(stats: Stat[]): ChartData[] {
    return [...stats].reverse().map((stat) => ({
        value: stat.value,
        label: new Date(stat.ts).toLocaleTimeString()
    }));
}